import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import MobileGate from './components/MobileGate';
import { bindAudioUnlock } from './lib/checkInAlarm';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 401 is handled by the axios refresh interceptor; retrying here
      // would just multiply requests that are going to fail the same way.
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

/**
 * Here, and not in PingWatcher, because of when each one runs.
 *
 * PingWatcher mounts after sign-in, so the click on the Sign In button — the
 * one interaction every user makes — happened before its listener existed.
 * Anyone who signed in and switched to another window never produced a second
 * gesture, and their check-in beep was silent for the rest of the session.
 * Bound at the entry, that click is the gesture.
 *
 * Never unbound. The listeners detach themselves the moment a resume succeeds,
 * and a page that is unloading has nothing to clean up.
 */
bindAudioUnlock();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* BASE_URL comes from vite's `base`, so the router works both at the
          root and under a sub-path when embedded behind a proxy. */}
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <MobileGate>
          <App />
        </MobileGate>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
